/**
 * @jsxRuntime classic
 * @jsx jsx
 */
/* eslint-disable @atlassian/tangerine/import/no-parent-imports */

import { useEffect } from 'react';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';
import { cssMap, jsx } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled';

import { ScreenLayout } from '../../components/screen-layout';
import { useModalContext } from '../../contexts/modal-context';

import { Content } from './modal-left';
import { ProductGraphic } from './modal-right';

const styles = cssMap({
	modal: {
		display: 'flex',
		height: '100%',
	},
});

export type NormalizeSeatScreenProps = {
	onConfirm: () => void;
	testId?: string;
};

export const NormalizeSeatScreen: (props: NormalizeSeatScreenProps) => JSX.Element = ({
	onConfirm,
	testId,
}: NormalizeSeatScreenProps): JSX.Element => {
	const { createAnalyticsEvent } = useAnalyticsEvents();
	const { sourceComponent, sourceContext } = useModalContext();

	useEffect(() => {
		createAnalyticsEvent({
			eventType: 'screen',
			name: 'twcXflowModalNormalizeSeatScreen',
			attributes: {
				sourceComponent,
				sourceContext,
			},
		}).fire('growth');
	}, [createAnalyticsEvent, sourceComponent, sourceContext]);

	return (
		<ScreenLayout testId="normalize-seat-screen">
			<Box xcss={styles.modal}>
				<Content onConfirm={onConfirm} testId={testId} />
				<ProductGraphic />
			</Box>
		</ScreenLayout>
	);
};
